import setReduxAction from 'modules/redux/actions/set'
import { BANNER_ACTION, BANNER_DOMAIN } from 'modules/banner/constants'
import getMessageErrorUtil from 'utils/error/get-message'
import { MESSAGE_TYPE } from 'constants/message'

/**
 * Sets the banner message.
 * @param  {Error|String} errorMessage
 * @returns {Function}
 */
function openErrorBannerAction (errorMessage) {
  const message = getMessageErrorUtil(errorMessage)
  const value = {
    message,
    type: MESSAGE_TYPE.ERROR
  }
  return setReduxAction({
    type: BANNER_ACTION.ERROR,
    payload: {
      path: BANNER_DOMAIN,
      value
    }
  })
}

export default openErrorBannerAction
